import { createSelector } from "reselect";

export const pendingSaveReducerSelector = createSelector(
  state => state.get("pendingSaveReducer"),
  pendingSaveReducer => pendingSaveReducer
);

export const pendingSaveCountSelector = createSelector(
  pendingSaveReducerSelector,
  pendingSaveReducer => pendingSaveReducer.get("count")
);

export const hasPendingSavesSelector = createSelector(
  pendingSaveCountSelector,
  count => count > 0
);
